<template>
  <vue-base-dialog ref="VueBaseDialog" :dialogConfig="dialogConfig" @close="closeBox">
    <div class="dialog-content">
      <video id="player-container-id" playsinline webkit-playsinline>
      </video>
    </div>
  </vue-base-dialog>
</template>
<script>
import VueBaseDialog from './VueBaseDialog'
export default {
  name: 'PlayBox',
  components: {
    VueBaseDialog
  },
  props: {
    dialogConfig: {
      type: Object,
      default: () => {
        return {
          type: "",
          name: "",
          fileId: "",
          path: "",
          title: "",
          isLevelLog: false, // 是否开启播放记录
          position: '',
        }
      }
    },
    addPlayLogMethod: { // 添加播放记录
      type: Function,
      default: null
    },
  },
  data () {
    return {
      player: null,
      currentTime: 0,
    }
  },

  mounted () {
    this.initPlayer();
  },
  beforeDestroy () {
    clearInterval(this.inter)
    this.inter = null
    this.player.dispose();
    this.player = null;
  },
  methods: {
    initPlayer () {
      let that = this
      this.player = window.TCPlayer('player-container-id', {
        width: 800,
        height: 450,
        fileID: this.dialogConfig.fileId,
        appID: '1500004122',
        posterImage: true,
        bigPlayButton: true,
        autoplay: false,
        controlBar: {
          playbackRateMenuButton: true,
          QualitySwitcherMenuButton: false,
        }
      });
      if (that.dialogConfig && that.dialogConfig.isLevelLog) {
        if (that.dialogConfig.position) {
          that.player.on('ready', function () {
            try {
              that.player.currentTime(that.dialogConfig.position);
              that.player.play().catch(e => console.error('Play failed:', e));
            } catch (e) {
              console.error('Error setting playback position:', e);
            }
          });
        }
        that.player.on("play", () => {
          that.inter = setInterval(() => {
            that.addPlayLogMethod()
          }, 15000);
        });
        that.player.on("ended", () => {
          clearInterval(that.inter)
          that.inter = null
          this.addPlayLogMethod()
        });
        that.player.on("pause", () => {
          clearInterval(that.inter)
          that.inter = null
          this.addPlayLogMethod()
        });
        that.player.on("error", () => {
          clearInterval(that.inter)
          that.inter = null
        });
      }
    },
    loadScript (url, callback) {
      if (typeof document !== "undefined") {
        var script = document.createElement("script");
      }
      script.type = "text/javascript";
      if (typeof callback !== "undefined") {
        if (script.readyState) {
          script.onreadystatechange = function () {
            if (script.readyState === "loaded" || script.readyState === "complete") {
              script.onreadystatechange = null;
              callback();
            }
          };
        } else {
          script.onload = function () {
            callback();
          };
        }
      }
      script.src = url;
      if (typeof document !== "undefined") {
        document.head.appendChild(script);
      }
    },
    closeBox () {
      this.$emit('closeBox', this.player.currentTime())
    }
  }
}
</script>
<style lang="less" scoped>
.dialog-content {
    text-align: left;
}
.public-dialog-btn-box {
    margin-top: 10px;
}
#player-container-id /deep/ .tcp-skin .vjs-progress-control {
    top: 0;
}
</style>